/*
 * @Author: yzr
 * @Date: 2020-11-24 10:02:34
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-24 10:08:55
 */
import TablePage from './table.vue';

export default TablePage;
